import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';

export interface OverlayAction {
    label: string;
    variant?: 'primary' | 'secondary' | 'warning' | 'danger';
    onClick: () => void;
    disabled?: boolean;
}

export interface OverlayProps {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    actions?: OverlayAction[];
    className?: string;
}

export const Overlay: React.FC<OverlayProps> = ({ title, onClose, children, actions, className }) => {
    useEffect(() => {
        // Block body scroll when overlay is mounted
        document.body.style.overflow = 'hidden';

        // Restore body scroll when overlay is unmounted
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <div className="overlay">
            <div className="inner">
                <div className={`overlay-content ${className || ''}`}>
                    <div className="overlay-header">
                        <h2>{title}</h2>
                        <button className="close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="overlay-body">
                        {children}
                    </div>

                    {actions && actions.length > 0 && (
                        <div className="overlay-footer">
                            {actions.map((action, index) => (
                                <Button
                                    key={index}
                                    variant={action.variant || 'primary'}
                                    onClick={action.onClick}
                                    disabled={action.disabled || false}
                                >
                                    {action.label}
                                </Button>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
